<template>
  <!-- 蓝鹰官网 -->
  <div class="homePage">
    <PageNav />
    <div class="main">
      <div class="page1">
        <img class="bg" src="../../assets/img/bg.png" alt="" />
        <div class="seccion">
          <div class="left">
            <p class="left_title">舆情产品</p>
            <h2>专业、开放、易用的互联网舆论分析平台</h2>
            <p>
              全方位分析互联网舆论，提供实时舆情、语义分析、搜索指数及事件脉络等数据与分析能力，助力客户把握时事脉搏。
            </p>
            <div>
              <div>
                <img :src="require('@/assets/img/apk_code.png')" alt="" />
                <span>安卓版</span>
              </div>
              <div>
                <img :src="require('@/assets/img/ios_code.png')" alt="" />
                <span>ios版</span>
              </div>
            </div>
          </div>
          <div class="right">
            <img class="img1" src="../../assets/img/p2.png" alt="" />
            <img class="img2" src="../../assets/img/p1.png" alt="" />
          </div>
        </div>
      </div>
      <div class="page2">
        <div>
          <div class="content1" id="n1">
            <h2>强大、安全、稳定、便捷</h2>
            <ul>
              <li v-for="(item, i) in list" :key="i">
                <div>
                  <i class="iconfont" :class="item.icon"></i>
                </div>
                <h6>{{ item.title }}</h6>
                <p>{{ item.desc }}</p>
              </li>
            </ul>
          </div>
          <div class="circularbg content2" id="n2">
            <div class="bg">
              <div class="circular min"></div>
              <div class="circular max"></div>
            </div>
            <div class="contentMain">
              <div class="info fl">
                <div class="title">全网事件分析</div>
                <p class="desc">
                  对某一网络事件在互联网上的整体传播情况，收集全网数据进行分析，自动生成涵盖事件简介、事件走势、网站统计、数据类型、关键词云、热门信息、热点网民、传播路径、相关词、网民观点、舆情总结等11个维度的全网事件分析报告。
                </p>
                <div class="cardTips">
                  <div class="item levelMiddle active">
                    <div class="icon middle">
                      <i class="iconfont icon-zhuanti"></i>
                    </div>
                    <span class="text">专题事件分析</span>
                  </div>
                  <div class="item levelMiddle active">
                    <div class="icon middle">
                      <i class="iconfont icon-weibo"></i>
                    </div>
                    <span class="text">微博博主分析</span>
                  </div>
                  <div class="item levelMiddle active">
                    <div class="icon middle">
                      <i class="iconfont icon-wodewenzhang"></i>
                    </div>
                    <span class="text">微博博文分析</span>
                  </div>
                </div>
              </div>
              <img class="fr" :src="require('@/assets/img/p3.jpg')" alt="" />
            </div>
          </div>
          <div class="circularbg content3" id="n3">
            <div class="bg">
              <div class="circular min"></div>
              <div class="circular max"></div>
            </div>
            <div class="contentMain">
              <div class="fl cardInfos clearfix">
                <div class="item" v-for="(el, index) in list2" :key="index">
                  <div class="itemMain middle">
                    <div class="logo">
                      <span class="cirbg"></span>
                      <i class="iconfont" :class="el.icon"></i>
                    </div>
                    <div class="name">{{ el.title }}</div>
                    <p class="desc">{{ el.desc }}</p>
                  </div>
                </div>
              </div>
              <div class="info fr">
                <div class="title">全快准稳的服务优势</div>
                <p class="desc">
                  网站、论坛等信息源最快3分钟轮询1次；预警信息最快1分钟下达；定向监测指定行业、指定信息源；自定义信息监测时间范围；支持横向扩展，可根据业务增长进行系统调整；
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page3 middle" id="n4">
        <div class="title">合作支持</div>
        <p class="desc">
          舆情监测已经成功帮助数百企业和个人进行数据的检测和管控，为客户分忧解难是我们的根本宗旨。您只需专心做产品和销售，让我们为您的网络舆情信息保驾护航！
        </p>
        <div class="cards">
          <div class="item middle">
            <div class="num">
              <span class="total">代理销售</span>
            </div>
            <div class="name">
              1.填写代理信息 2.专人一对一接待洽谈 3.确认合作意向
              4.成为舆情通代理合作伙伴
            </div>
          </div>
          <div class="item middle">
            <div class="num">
              <span class="total">公司合作</span>
            </div>
            <div class="name">
              网络舆情怎么监测？人工太费时？担心没效果？舆情通，通通帮你解决！
            </div>
          </div>
          <div class="item middle">
            <div class="num">
              <span class="total">售后保障</span>
            </div>
            <div class="name">
              在签订合同的有效期内为客户长期维护、保持良好的信誉口碑，让您更好一面展示在众人面前。
            </div>
          </div>
        </div>
        <div class="contactUs middle">联系我们</div>
        <div class="tipList">
          <!-- <p class="item">Cooperative enterprises logo</p>
                    <p class="item">Cooperative enterprises logo</p>
                    <p class="item">Cooperative enterprises logo</p>
                    <p class="item">Cooperative enterprises logo</p> -->
        </div>
      </div>
      <div class="page4 middle" id="n5">
        <div class="title">解决方案</div>
        <div class="list">
          <div class="item middle">
            <img :src="'../../assets/img/0.png'" alt="" />
            <p>品牌数字化</p>
            <!-- <div class="date"> 2020-07-02</div> -->
          </div>
          <div class="item middle">
            <img :src="'../../assets/img/1.png'" alt="" />
            <p>产品创新数字化</p>
            <!-- <div class="date"> 2020-07-15</div> -->
          </div>
          <div class="item middle">
            <img :src="'../../assets/img/2.jpg'" alt="" />
            <p>渠道数据化</p>
            <!-- <div class="date"> 2020-07-22</div> -->
          </div>
        </div>
      </div>
      <div class="page5 middle" id="n6">
        <p class="what">你还在犹豫什么？</p>
        <p class="comeon">马上免费试用!</p>
        <div class="imgTip">
          <div>
            <img :src="require('@/assets/img/apk_code.png')" alt="" />
            <span>安卓版</span>
          </div>
          <div>
            <img :src="require('@/assets/img/ios_code.png')" alt="" />
            <span>ios版</span>
          </div>
        </div>
      </div>
      <div class="page6 middle" id="n7">
        <div class="infoMain">
          <div class="fl">
            <div class="item product">
              <div class="name">产品</div>
              <div class="list">
                <span>产品介绍</span>
                <span>产品服务</span>
              </div>
            </div>
            <div class="item company">
              <div class="name">企业介绍</div>
              <div class="list">
                <span>关于我们</span>
                <span>社区</span>
                <span
                  class="list_item_active"
                  @click="openPage('/privacyPolicy')"
                  >隐私政策</span
                >
              </div>
            </div>
          </div>
          <div class="fr">
            <div class="name">广州数源智汇科技有限公司</div>
            <div class="contact">
              <p>地址：广州市天河区高普路136号第一层151单元</p>
              <p>电话：020-38891740</p>
              <p>邮编：510000</p>
            </div>
          </div>
        </div>
        <div class="version">备案号： {{ versionNumber }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from "./pageNav.vue";

export default {
  components: {
    PageNav
  },
  data() {
    return {
      list: [
        {
          icon: "icon-101",
          title: "舆情监测",
          desc:
            "24小时实时监测互联网全量信息\n微博原文失效信息检测；\nOCR图文识别\n小视频监测"
        },
        {
          icon: "icon-yujing",
          title: "推送预警",
          desc:
            "系统智能预警+人工服务相结合;\n支持微信公众号、pc弹窗、手机APP、邮件等多种预警方式"
        },
        {
          icon: "icon-sousuo",
          title: "全网搜索",
          desc:
            "覆盖星光数据+各大搜索引擎；\n通过关键词搜索全网相关信息；\n多维度一键查找目标"
        },
        {
          icon: "icon-zhinengchanpin",
          title: "智能舆情报告",
          desc:
            "日、周、月、简报等系统智能分析、自动生成；\n支持自定义报告模板；\n事件分析、追溯首发、层层剖析、一键导出。"
        },
        {
          icon: "icon-tiaochaquzheng",
          title: "区块链存证取证服务",
          desc:
            "在线存取证、快速出具电子证书；\n无缝对接司法区块链各节点；\n可信第三方存证、取证、出证，确保电子证据证明效力。"
        },
        {
          icon: "icon-keshihua",
          title: "态势感知可视化分析",
          desc:
            "智能化舆情数据分析；\n明辨舆情态势；\n发掘薄弱环节；\n预测舆情走势。"
        }
      ],
      list2: [
        {
          icon: "icon-quanmianfugai",
          title: "全面",
          desc:
            "7x24x365全天候实时监测微博、贴吧秒级全量采集信源全网覆盖：网站、微博、论坛、微信公众号、视频、APP、报刊等多语种境外数据"
        },
        {
          icon: "icon-xiangyingchaoshi",
          title: "及时",
          desc:
            "信息抓取频率分钟级舆情发生1分钟以内预警推送,重大事件实时预警从创建监测到数据呈现≤5秒"
        },
        {
          icon: "icon-kujialeqiyezhan_jingzhunputie",
          title: "精准",
          desc:
            "自动预警准确率达97%事件演化分析正确率 85%+精准配置,关键信息零遗漏"
        },
        {
          icon: "icon-wending",
          title: "稳定",
          desc:
            "处理时延不到1 秒3亿条数据下，秒级响应原始数据浏览、智能检索、分析结果查看等"
        }
      ]
    };
  },
  computed: {
    versionNumber() {
      let num = "粤ICP备15073179号";
      if (location.host.indexOf("datatell") > -1) num = "粤ICP备2022043483号";
      return num;
    }
  },
  methods: {
    openPage(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="less" scoped>
.homePage {
  width: 100%;
  background: url("../../assets/img/bg2.png");
  background-size: 18px auto;
  .main {
    width: 100%;
    .page1 {
      width: 100%;
      height: 100vh;
      position: relative;
      overflow: hidden;
      .bg {
        width: 100%;
        height: auto;
      }
      .seccion {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .left {
          width: 60%;
          color: #fff;
          padding-top: 150px;
          > h2 {
            font-size: 50px;
          }
          > p {
            font-size: 16px;
            margin: 20px 0 120px;
          }
          .left_title {
            margin-bottom: 10px;
            font-size: 26px;
          }
          > div {
            display: flex;
            align-items: center;
            > div {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 40px;
              > img {
                width: 120px;
                margin-bottom: 10px;
                border-radius: 5px;
              }
            }
            // > img {
            //   width: auto;
            //   height: 60px;
            //   margin-right: 20px;
            //   &:nth-last-child(1) {
            //     margin: 0;
            //   }
            // }
          }
        }
        .right {
          width: 40%;
          display: flex;
          align-items: flex-end;
          .img1 {
            height: 60vh;
            transform: translateX(110px) translateY(-17px);
          }
          .img2 {
            height: 70vh;
            position: relative;
            z-index: 10;
          }
        }
      }
    }
    .page2 {
      display: flex;
      justify-content: center;
      > div {
        width: 1000px;
        .circularbg {
          position: relative;
          padding-top: 120px;
          padding-bottom: 200px;
          .bg {
            position: relative;
            z-index: 1;
            .circular {
              background-color: #3b43f2;
              border-radius: 50%;
              position: absolute;
              &.min {
                width: 110px;
                height: 110px;
              }
              &.max {
                width: 650px;
                height: 650px;
              }
            }
          }
          .contentMain {
            position: relative;
            z-index: 2;
            display: flex;
          }
          .info {
            position: relative;
            z-index: 2;
            width: 500px;
            .title {
              font-size: 48px;
              white-space: wrap;
              width: 272px;
              color: #000;
            }
            .desc {
              font-size: 16px;
              color: #999;
              width: 357px;
              margin-top: 20px;
            }
          }
        }
        .content1 {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          > h2 {
            font-size: 35px;
            margin: 70px 0 70px;
          }
          > ul {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            > li {
              width: 30%;
              height: 300px;
              background: #fff;
              box-shadow: rgba(69, 158, 255, 0.1) 0px 10px 20px 0px;
              margin-bottom: 40px;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 40px 20px 0;
              box-sizing: border-box;
              transition: all 0.5s;
              &:hover {
                transform: scale(1.05);
              }
              > div {
                width: 80px;
                height: 80px;
                border-radius: 100%;
                background: rgba(69, 158, 255, 0.1);
                display: flex;
                align-items: center;
                justify-content: center;
                > i {
                  font-size: 60px;
                  position: relative;
                  left: 10px;
                  top: -5px;
                  color: #333;
                }
              }
              > h6 {
                font-size: 18px;
                margin: 20px 0 30px;
              }
              > p {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
        .content2 {
          .bg {
            .circular {
              &.min {
                margin-left: 415px;
              }
              &.max {
                margin-left: 489px;
                margin-top: 81px;
              }
            }
          }
          .fl {
            .cardTips {
              margin-top: 130px;
              .item {
                width: 357px;
                border-radius: 6px;
                padding: 20px;
                margin-bottom: 50px;
                justify-content: flex-start;
                transition: all 0.5s;
                &:hover {
                  transform: scale(1.05);
                }
                &:nth-child(2n) {
                  margin-left: 100px;
                }
                &.active {
                  background-color: #fff;
                  box-shadow: 0 0 25px rgba(0, 0, 0, 0.27);
                }
                .icon {
                  background: rgba(69, 158, 255, 0.1);
                  border-radius: 6px;
                  width: 56px;
                  height: 56px;
                  line-height: 32px;
                  margin-left: 20px;
                  margin-right: 30px;
                  i {
                    font-size: 32px;
                    color: #459eff;
                  }
                }
                .text {
                  font-size: 24px;
                  line-height: 56px;
                  color: #233d63;
                }
              }
            }
          }
          .fr {
            width: 375px;
            margin-left: 126px;
            margin-top: -10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.27);
            border-radius: 6px;
          }
        }
        .content3 {
          .bg {
            .circular {
              &.min {
                margin-left: 568px;
              }
              &.max {
                margin-left: -70px;
                margin-top: 60px;
              }
            }
          }
          .contentMain {
            // display: block;
          }
          .cardInfos {
            min-width: 510px;
            max-width: 510px;
            // margin-left: 185px;
            padding-top: 64px;
            .item {
              float: left;
              display: inline-block;
              background-color: #fff;
              box-shadow: 0 0 15px rgba(59, 64, 70, 0.3);
              border-radius: 6px;
              margin-bottom: 30px;
              margin-right: 30px;
              width: 223px;
              height: 343px;
              transition: all 0.5s;
              &:hover {
                transform: scale(1.05);
              }
              &:nth-child(1),
              &:nth-child(3) {
                margin-top: -114px;
              }
              .itemMain {
                width: 100%;
                height: 100%;
                .logo {
                  position: relative;
                  .cirbg {
                    position: absolute;
                    width: 78px;
                    height: 78px;
                    border-radius: 50%;
                    background-color: rgba(69, 158, 255, 0.1);
                    margin-top: 10px;
                    margin-left: -10px;
                  }
                  i {
                    font-size: 78px;
                    line-height: 78px;
                    position: relative;
                    z-index: 3;
                  }
                }
                .name {
                  margin-top: 50px;
                  font-size: 24px;
                }
                .desc {
                  font-size: 16px;
                  color: #999;
                  text-align: center;
                  padding: 20px;
                }
              }
            }
          }
          .fr {
            margin-left: 200px;
            margin-top: 200px;
          }
        }
      }
    }
    .page3 {
      background-color: rgba(69, 158, 255, 0.1);
      margin-top: 100px;
      .title {
        color: #459eff;
        font-size: 48px;
        margin-top: 60px;
        text-align: center;
      }
      .desc {
        font-size: 16px;
        color: #999;
        text-align: center;
        margin-top: 30px;
        max-width: 1084px;
      }
      .cards {
        margin-top: 70px;
        display: flex;
        justify-content: space-between;
        width: 900px;
        margin-left: -20px;
        .item {
          flex: 1;
          background-color: #fff;
          border-radius: 6px;
          box-shadow: 0 0 20px rgba(65, 157, 255, 0.4);
          margin-left: 20px;
          padding-top: 40px;
          padding-bottom: 40px;
          transition: all 0.5s;
          &:hover {
            transform: scale(1.05);
          }
          .num {
            color: #459eff;
            font-size: 30px;
          }
          .name {
            font-size: 14px;
            color: #888;
            margin-top: 20px;
            padding: 0 20px;
            box-sizing: border-box;
          }
        }
      }
      .contactUs {
        width: 151px;
        height: 50px;
        color: #fff;
        background-color: #459eff;
        border-radius: 25px;
        margin-top: 60px;
        transition: all 0.5s;
        cursor: pointer;
        &:hover {
          transform: scale(1.05);
        }
      }
      .tipList {
        display: flex;
        justify-content: space-between;
        max-width: 1400px;
        margin-top: 60px;
        margin-bottom: 60px;
        .item {
          color: #459eff;
          width: 255px;
          font-size: 28px;
          font-weight: 600;
        }
      }
    }
    .page4 {
      padding-bottom: 130px;
      .title {
        font-size: 35px;
        color: #000;
        margin-top: 100px;
      }
      .list {
        margin-top: 50px;
        margin-left: -20px;
        max-width: 900px;
        display: flex;
        .item {
          margin-left: 20px;

          &:hover {
            img {
              transform: scale(1.05);
            }
          }
          img {
            width: 100%;
            border-radius: 5px;
            transition: all 0.5s;
            // height: 180px;
          }
          p {
            padding-left: 15px;
            padding-right: 15px;
            font-size: 24px;
            color: #666;
            margin-top: 15px;
          }
          .date {
            padding-left: 15px;
            font-size: 13px;
            margin-top: 25px;
            width: 100%;
            color: #666;
          }
        }
      }
    }
    .page5 {
      background-color: #3b43f2;
      color: #fff;
      min-height: 480px;
      padding-top: 30px;
      .what {
        font-size: 18px;
      }
      .comeon {
        font-size: 60px;
        margin-top: 30px;
      }
      .imgTip {
        display: flex;
        margin-top: 60px;
        margin-bottom: 30px;
        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 40px;
          > img {
            width: 120px;
            margin-bottom: 10px;
            border-radius: 5px;
          }
        }
      }
    }
    .page6 {
      padding-top: 180px;
      padding-bottom: 100px;

      .infoMain {
        display: flex;
        .fl {
          display: flex;
          .item {
            min-width: 300px;
            .name {
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }
            .list {
              font-size: 14px;
              margin-top: 35px;
              span {
                display: block;
                margin-bottom: 20px;
                color: #999;
              }
              .list_item_active {
                cursor: pointer;
                &:hover {
                  color: #3b43f2;
                }
              }
            }
          }
        }
        .fr {
          .name {
            font-size: 20px;
            color: #101010;
          }
          .contact {
            margin-top: 20px;
            font-size: 14px;
            color: #aeaeae;
            > p {
              margin-bottom: 6px;
            }
          }
        }
      }
      .version {
        margin-top: 30px;
        color: #999;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue